import { toast } from 'sonner';
import { apiPost, operationsClient } from '@/lib/api';

export async function uploadStagedFiles(files: File[], uploadUrlPath: string): Promise<void> {
  for (const file of files) {
    try {
      const { uploadUrl } = await apiPost<{ uploadUrl: string }>(operationsClient, uploadUrlPath, {
        filename: file.name,
        contentType: file.type,
        fileSize: file.size,
      });
      await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': file.type },
      });
    } catch {
      toast.error(`Failed to upload ${file.name}`);
    }
  }
}
